import React from 'react';

import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';

import { DeviceProvider } from '@vyce/core/src/contexts';
import { useAppTheme } from '@vyce/core/src/hooks/useAppTheme';
import { useDeviceData } from '@vyce/core/src/hooks/useDeviceData';
import NotificationProvider from '@vyce/core/src/contexts/notificationContext';
import '@vyce/core/firebase';

import { store } from './store';
import { InvitesProvider } from './store/invites-context';
import { Main } from './views/main/Main';

export const App = () => {
  const { changeColorTheme, themeType, colorTheme, theme } = useAppTheme();
  const { isMobile, isDesktop, isLargeDesktop, iOS, isTablet } = useDeviceData();

  return (
    <div id="app">
      <Provider store={store}>
        <DeviceProvider value={{ isMobile, isDesktop, isLargeDesktop, iOS, isTablet }}>
          <Router
            getUserConfirmation={() => {
              /* Empty callback to block the default browser prompt */
            }}
          >
            <NotificationProvider>
              <InvitesProvider>
                <Main
                  theme={theme}
                  changeColorTheme={changeColorTheme}
                  themeType={themeType}
                  colorTheme={colorTheme}
                />
              </InvitesProvider>
            </NotificationProvider>
          </Router>
        </DeviceProvider>
      </Provider>
    </div>
  );
};
